/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface SuiviFichierUploadDto
 */
export interface SuiviFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof SuiviFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierUploadDto
     */
    idsuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierUploadDto
     */
    idsuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierUploadDto
     */
    idtypeSuiviFichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the SuiviFichierUploadDto interface.
 */
export function instanceOfSuiviFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviFichierUploadDtoFromJSON(json: any): SuiviFichierUploadDto {
    return SuiviFichierUploadDtoFromJSONTyped(json, false);
}

export function SuiviFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idsuiviFichier': !exists(json, 'idsuiviFichier') ? undefined : json['idsuiviFichier'],
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function SuiviFichierUploadDtoToJSON(value?: SuiviFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idsuiviFichier': value.idsuiviFichier,
        'idsuivi': value.idsuivi,
        'idfichier': value.idfichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'fileName': value.fileName,
    };
}

